// Yandex social-login button — ports the original #yandex-login-btn (.button-tertiary
// with the red Yandex "Я" logo). The only social provider shown in the original UI.

import s from '../screens/auth.module.css'

const YANDEX_LOGO = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8 }}>
    <path d="M2.04 12c0-5.523 4.476-10 10-10 5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.524 0-10-4.477-10-10z" fill="#FC3F1D" />
    <path d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.487H7.49l2.695-4.014c-1.55-1.111-2.42-2.19-2.42-4.015 0-2.288 1.595-3.85 4.62-3.85h3.003v11.868H13.32V7.666z" fill="#fff" />
  </svg>
)

interface YandexButtonProps {
  label: string
  onClick: () => void
  disabled?: boolean
}

export default function YandexButton({ label, onClick, disabled }: YandexButtonProps) {
  return (
    <button type="button" className={`${s.button} ${s.tertiary}`} onClick={onClick} disabled={disabled}>
      {YANDEX_LOGO}
      {label}
    </button>
  )
}
